import $ from 'jquery'
import expandCollapseUi from '@/nav/expandCollapseUi'
import 'bootstrap/js/tab'

export const initializeInfoTabs = () => {
  $('.collapse-container a').on('click', function (e) {
    const $link = $(this)
    const $outerItem = $link.parent()
    expandCollapseUi(e, $outerItem)
  })
}
